import { joinWithComma } from '../../../common/helpers/joinWithComma.helper';
import { theme } from '../../../common/ui/theme';
import { InputContainerProps } from '../../Input/components/InputContainer';

export const getDateInputBoxShadow = (props: InputContainerProps): string => {
    if (props.$isFocused && props.$negative) {
        return joinWithComma(theme.shadows.border.negative, theme.shadows.focus);
    }
    if (props.$isFocused) {
        return joinWithComma(theme.shadows.focus, theme.shadows.border.default);
    }
    return props.$negative
        ? joinWithComma(theme.shadows.border.negative, theme.shadows.select.base)
        : joinWithComma(theme.shadows.select.base, theme.shadows.border.default);
};

export const getDateInputHoverBoxShadow = (props: InputContainerProps): string | null => {
    if (props.$isFocused && props.$negative) {
        return joinWithComma(theme.shadows.border.negative, theme.shadows.focus);
    }
    if (props.$isFocused) {
        return joinWithComma(theme.shadows.focus, theme.shadows.border.default);
    }
    if (props.$negative) {
        return joinWithComma(theme.shadows.border.negative, theme.shadows.select.hover);
    }
    return props.disabled ? null : joinWithComma(theme.shadows.select.hover, theme.shadows.border.default);
};
